export const EVENTS = {
  accept: "accept",
  start: "start",
  ready: "ready",
  stop: "stop",
  save: "save",
  fail: "fail",
  termsAndConditions: "terms and conditions",
};
